import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-loader',
    templateUrl: './loader.component.html',
    styleUrls: ['./loader.component.scss'],
    standalone: false
})
export class LoaderComponent {
  @Input() message: string;

  /**
   * Render in the flow instead of as a full-screen overlay. For loading that
   * adds to what is already on screen — a table paging in its next rows —
   * where dimming the whole page on every scroll would be wrong.
   */
  @Input() inline = false;
}
